import { observable, runInAction } from 'mobx';
import { CommonModel, ICommonServices, ProductModel } from 'services/Main/common_services';
import { DataResponse } from 'services/response';

export type CommonStore = {
  commonRespone: {
    data: CommonModel[];
    message: string;
    isSuccess: boolean;
  };

  nhomHangMuaNhieu: {
    data: CommonModel[];
    message: string;
    isSuccess: boolean;
  };

  commonDate: {
    fromDate: string;
    toDate: string;
  };
  // Danh sách chi nhánh
  commonStore: CommonModel[],

  productData: DataResponse<ProductModel[]>

};

export interface ICommonPresenter {
  createStore(): CommonStore;
  // =====================COMMON DATE===========================
  // lấy ngày từ common date
  getDateByCommonDate(store: CommonStore, date: string): Promise<void>;

  // =================================================================
  // Lấy data danh sách công ty
  getListSaleOrg(store: CommonStore, type?: string): Promise<void>;
  // Lấy danh sách common date
  getListSelectCommonDate(store: CommonStore, type?: string): Promise<void>;
  // Lấy data danh sách store
  getListSelectCommonStore(store: CommonStore, accountId: string): Promise<void>;
  // Lấy danh sách dự án
  getListOpportunities(store: CommonStore, key?: string): Promise<void>;
  // Lấy danh sách Nhân viên kinh doanh
  getListPersonInCharge(store: CommonStore, key?: string): Promise<void>;

  // GET data common theo key:
  // Dropdown Khu vực : SaleOffice
  getCommonDataByKey(store: CommonStore, key: string, custom?: string, company?: string): Promise<void>;
  // lấy danh Tỉnh/Thành phố
  getListProvince(store: CommonStore, area?: string): Promise<void>;
  // lấy danh quận huyện
  getListDistrict(store: CommonStore, province: string[], key?: string, area?: string): Promise<void>;
  // lấy danh phường xã
  getListWard(store: CommonStore, district: string[], key?: string): Promise<void>;
  // lấy danh phường xã theo tỉnh/thành (sau sáp nhập, không còn đi qua quận/huyện)
  getListWardByProvince(store: CommonStore, province: string[], key?: string): Promise<void>;
  // Lấy danh sách tiêu chí (ds lọc)
  getListFilter(store: CommonStore, key: string): Promise<void>;
  //Danh sách người tạo
  getListCreateBy(store: CommonStore, key?: string): Promise<void>;
  //Danh sách người tạo
  getListCreateBy(store: CommonStore, key?: string): Promise<void>;
  //Danh sách phòng ban
  getListDepartment(store: CommonStore, key?: string, congty?: string): Promise<void>;
  // Danh sách khách hàng
  getListCustomer(store: CommonStore, key?: string): Promise<void>;
  getListCustomerHasId(store: CommonStore, key?: string): Promise<CommonModel[]>;
  // danh sách công ty theo tài khoản
  getCompanyByAccount(store: CommonStore): Promise<void>;
  getCompanyByAccountHasId(store: CommonStore): Promise<void>;
  // danh sách chi nhánh theo tài khoản
  getStoreByAccount(store: CommonStore): Promise<void>;
  // Danh sách email
  getListEmail(store: CommonStore): Promise<void>;
  // Danh sách nội dung
  getListContents(store: CommonStore, key?: string): Promise<void>;
  // Danh sách customer segment
  getListCustomerSegment(store: CommonStore, key?: string): Promise<void>;
  // danh sách khu vực theo quốc gia
  getListAreaByNation(store: CommonStore, key: any): Promise<void>;
  // danh sách chủ đầu tư
  getListInvestors(store: CommonStore, key?: string): Promise<void>;
  // danh sách nhóm mua hàng
  getListOrderSeller(store: CommonStore, key?: string): Promise<void>;
  // Danh sách nhà thiết kế
  getListDesigner(store: CommonStore, key?: string): Promise<void>;
  // danh sách tổng thầu
  getListContracter(store: CommonStore, key?: string): Promise<void>;
  // Danh sách đối thủ
  getListCompetitor(store: CommonStore, key?: string): Promise<void>;
  // xác suất dự án
  getListOpportunitypercent(store: CommonStore, key?: string): Promise<void>;
  // Năm hoàn thiện
  getListOpportunityyear(store: CommonStore): Promise<void>;
  // Tên bảo hành
  getListWarrantyName(store: CommonStore): Promise<void>;

  // sản phẩm thị hiếu lấy từ acshopping
  getListSPTH(store: CommonStore, key?: string): Promise<void>;

  // lấy danh sách chi nhánh theo mã công ty
  getBranchByCompany(store: CommonStore, company?: string): Promise<void>;

  // lấy danh sách nhóm vật tư
  getListMaterialGroup(store: CommonStore, data?: object): Promise<void>;
  // phân loại vật tư
  getListMaterialClass(store: CommonStore, data?: object): Promise<void>;
  // sản phẩm
  getListProduct(store: CommonStore, data?: object): Promise<void>;


  // get domain email
  getDomainEmail(store: CommonStore): Promise<void>;
  // get email type
  getEmailType(store: CommonStore): Promise<void>;
  // danh sách chương trình
  getListProgram(store: CommonStore, key?: string): Promise<void>;
  //
  getListRole(store: CommonStore, role?: string, company?: string): Promise<void>;

}

export function createCommonPresenter({ commonServices }: { commonServices: ICommonServices }): ICommonPresenter {
  return {
    createStore: (): CommonStore =>
      observable({
        commonRespone: {
          data: [],
          message: '',
          isSuccess: false,
        },
        nhomHangMuaNhieu: {
          data: [],
          message: '',
          isSuccess: false,
        },
        commonDate: {
          fromDate: '',
          toDate: ''
        },
        productData: {
          data: [],
          message: '',
          isSuccess: false,
        },
        // Danh sách chi nhánh
        commonStore: [],
      }),
    // ======================================= COMMON DATE ==================================================
    // lấy ngày từ common date
    getDateByCommonDate: async (store, date: string) => {
      try {
        const result = await commonServices.getDateByCommonDate(date);
        runInAction(() => {
          store.commonDate = result;
        });
      } catch (error) {
        console.log(error);
      }
    },

    // ======================================================================================================
    // Hàm lấy data danh sách công ty
    getListSaleOrg: async (store, type) => {
      try {
        const result = await commonServices.getListSaleOrg(type);
        runInAction(() => {
          store.commonRespone.data = result.data;
          store.commonRespone.isSuccess = result.isSuccess;
          store.commonRespone.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // Lấy danh sách common date
    getListSelectCommonDate: async (store, type) => {
      try {
        const result = await commonServices.getListSelectCommonDate(type);
        runInAction(() => {
          store.commonRespone.data = result.data;
          store.commonRespone.isSuccess = result.isSuccess;
          store.commonRespone.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // Lấy data danh sách store
    getListSelectCommonStore: async (store, accountId) => {
      try {
        const result = await commonServices.getListSelectCommonStore(accountId);
        runInAction(() => {

          if (result.isSuccess) store.commonStore = result.data;
          else store.commonStore = []
        });
      } catch (error) {
        console.log(error);
      }
    },
    // Lấy danh sách dự án
    getListOpportunities: async (store, key) => {
      try {
        const result = await commonServices.getListOpportunities(key);
        runInAction(() => {
          store.commonRespone.data = result.data;
          store.commonRespone.isSuccess = result.isSuccess;
          store.commonRespone.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // Lấy danh sách nhân viên kinh doanh
    getListPersonInCharge: async (store, key) => {
      try {
        const result = await commonServices.getListPersonInCharge(key);
        runInAction(() => {
          store.commonRespone.data = result.data;
          store.commonRespone.isSuccess = result.isSuccess;
          store.commonRespone.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // GET data common theo key:
    // Dropdown Khu vực : SaleOffice
    getCommonDataByKey: async (store, key, custom, company) => {
      try {
        const result = await commonServices.getCommonDataByKey(key, custom, company);
        runInAction(() => {
          store.commonRespone.data = result.data;
          store.commonRespone.isSuccess = result.isSuccess;
          store.commonRespone.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // lấy danh Tỉnh/Thành phố
    getListProvince: async (store, area) => {
      try {
        const result = await commonServices.getListProvince(area);
        runInAction(() => {
          store.commonRespone.data = result.data;
          store.commonRespone.isSuccess = result.isSuccess;
          store.commonRespone.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // lấy danh quận huyện
    getListDistrict: async (store, province, key, area) => {
      try {
        const result = await commonServices.getListDistrict(province, key, area);
        runInAction(() => {
          store.commonRespone.data = result.data;
          store.commonRespone.isSuccess = result.isSuccess;
          store.commonRespone.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // lấy danh phường xã
    getListWard: async (store, district, key) => {
      try {
        const result = await commonServices.getListWard(district, key);
        runInAction(() => {
          store.commonRespone.data = result.data;
          store.commonRespone.isSuccess = result.isSuccess;
          store.commonRespone.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // lấy danh phường xã theo tỉnh/thành (sau sáp nhập, không còn đi qua quận/huyện)
    getListWardByProvince: async (store, province, key) => {
      try {
        const result = await commonServices.getListWardByProvince(province, key);
        runInAction(() => {
          store.commonRespone.data = result.data;
          store.commonRespone.isSuccess = result.isSuccess;
          store.commonRespone.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // Lấy danh sách tiêu chí (ds lọc)
    getListFilter: async (store, key) => {
      try {
        const result = await commonServices.getListFilter(key);
        runInAction(() => {
          store.commonRespone.data = result.data;
          store.commonRespone.isSuccess = result.isSuccess;
          store.commonRespone.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    //Danh sách người tạo
    getListCreateBy: async (store, key) => {
      try {
        const result = await commonServices.getListCreateBy(key);
        runInAction(() => {
          store.commonRespone.data = result.data;
          store.commonRespone.isSuccess = result.isSuccess;
          store.commonRespone.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    //Danh sách phòng ban
    getListDepartment: async (store, key, congty) => {
      try {
        const result = await commonServices.getListDepartment(key, congty);
        runInAction(() => {
          store.commonRespone.data = result.data;
          store.commonRespone.isSuccess = result.isSuccess;
          store.commonRespone.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // Danh sách khách hàng
    getListCustomer: async (store, key) => {
      try {
        const result = await commonServices.getListCustomer(key);
        runInAction(() => {
          store.commonRespone.data = result.data;
          store.commonRespone.isSuccess = result.isSuccess;
          store.commonRespone.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    getListCustomerHasId: async (store, key) => {
      try {
        const result = await commonServices.getListCustomerHasId(key);
        runInAction(() => {
          store.commonRespone.data = result.data;
          store.commonRespone.isSuccess = result.isSuccess;
          store.commonRespone.message = result.message;
        });
        return result.data
      } catch (error) {
        console.log(error);
        return []
      }
    },
    // danh sách công ty theo tài khoản
    getCompanyByAccount: async (store) => {
      try {
        const result = await commonServices.getCompanyByAccount();
        runInAction(() => {
          store.commonRespone.data = result.data;
          store.commonRespone.isSuccess = result.isSuccess;
          store.commonRespone.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // danh sách công ty theo tài khoản
    getCompanyByAccountHasId: async (store) => {
      try {
        const result = await commonServices.getCompanyByAccountHasId();
        runInAction(() => {
          store.commonRespone.data = result.data;
          store.commonRespone.isSuccess = result.isSuccess;
          store.commonRespone.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // danh sách chi nhánh theo tài khoản
    getStoreByAccount: async (store) => {
      try {
        const result = await commonServices.getStoreByAccount();
        runInAction(() => {
          store.commonRespone.data = result.data;
          store.commonRespone.isSuccess = result.isSuccess;
          store.commonRespone.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // Danh sách email
    getListEmail: async (store) => {
      try {
        const result = await commonServices.getListEmail();
        runInAction(() => {
          store.commonRespone.data = result.data;
          store.commonRespone.isSuccess = result.isSuccess;
          store.commonRespone.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // Danh sách nội dung
    getListContents: async (store, key) => {
      try {
        const result = await commonServices.getListContents(key);
        runInAction(() => {
          store.commonRespone.data = result.data;
          store.commonRespone.isSuccess = result.isSuccess;
          store.commonRespone.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // Danh sách customer segment
    getListCustomerSegment: async (store, key) => {
      try {
        const result = await commonServices.getListCustomerSegment(key);
        runInAction(() => {
          store.commonRespone.data = result.data;
          store.commonRespone.isSuccess = result.isSuccess;
          store.commonRespone.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // danh sách khu vực theo quốc gia
    getListAreaByNation: async (store, key) => {
      try {
        const result = await commonServices.getListAreaByNation(key);
        runInAction(() => {
          store.commonRespone.data = result.data;
          store.commonRespone.isSuccess = result.isSuccess;
          store.commonRespone.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // danh sách chủ đầu tư
    getListInvestors: async (store, key) => {
      try {
        const result = await commonServices.getListInvestors(key);
        runInAction(() => {
          store.commonRespone.data = result.data;
          store.commonRespone.isSuccess = result.isSuccess;
          store.commonRespone.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // danh sách nhóm mua hàng
    getListOrderSeller: async (store, key) => {
      try {
        const result = await commonServices.getListOrderSeller(key);
        runInAction(() => {
          store.nhomHangMuaNhieu.data = result.data;
          store.nhomHangMuaNhieu.isSuccess = result.isSuccess;
          store.nhomHangMuaNhieu.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // Danh sách nhà thiết kế
    getListDesigner: async (store, key) => {
      try {
        const result = await commonServices.getListDesigner(key);
        runInAction(() => {
          store.commonRespone.data = result.data;
          store.commonRespone.isSuccess = result.isSuccess;
          store.commonRespone.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // danh sách tổng thầu
    getListContracter: async (store, key) => {
      try {
        const result = await commonServices.getListContracter(key);
        runInAction(() => {
          store.commonRespone.data = result.data;
          store.commonRespone.isSuccess = result.isSuccess;
          store.commonRespone.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // Danh sách đối thủ
    getListCompetitor: async (store, key) => {
      try {
        const result = await commonServices.getListCompetitor(key);
        runInAction(() => {
          store.commonRespone.data = result.data;
          store.commonRespone.isSuccess = result.isSuccess;
          store.commonRespone.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // xác suất dự án
    getListOpportunitypercent: async (store, key) => {
      try {
        const result = await commonServices.getListOpportunitypercent(key);
        runInAction(() => {
          store.commonRespone.data = result.data;
          store.commonRespone.isSuccess = result.isSuccess;
          store.commonRespone.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // Năm hoàn thiện
    getListOpportunityyear: async (store) => {
      try {
        const result = await commonServices.getListOpportunityyear();
        runInAction(() => {
          store.commonRespone.data = result.data;
          store.commonRespone.isSuccess = result.isSuccess;
          store.commonRespone.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // Tên bảo hành
    getListWarrantyName: async (store) => {
      try {
        const result = await commonServices.getListWarrantyName();
        runInAction(() => {
          store.commonRespone.data = result.data;
          store.commonRespone.isSuccess = result.isSuccess;
          store.commonRespone.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // sản phẩm thị hiếu lấy từ acshopping
    getListSPTH: async (store, key) => {
      try {
        const result = await commonServices.getListSPTH(key);
        runInAction(() => {
          store.commonRespone.data = result.data;
          store.commonRespone.isSuccess = result.isSuccess;
          store.commonRespone.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // lấy danh sách chi nhánh theo mã công ty
    getBranchByCompany: async (store, company) => {
      try {
        const result = await commonServices.getBranchByCompany(company);
        runInAction(() => {
          store.commonRespone.data = result.data;
          store.commonRespone.isSuccess = result.isSuccess;
          store.commonRespone.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },

    // danh sách nhóm vật tư
    getListMaterialGroup: async (store, key) => {
      try {
        const result = await commonServices.getListMaterialGroup(key);
        runInAction(() => {
          store.commonRespone.data = result.data;
          store.commonRespone.isSuccess = result.isSuccess;
          store.commonRespone.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // danh sách phân loại vật tư
    getListMaterialClass: async (store, key) => {
      try {
        const result = await commonServices.getListMaterialClass(key);
        runInAction(() => {
          store.commonRespone.data = result.data;
          store.commonRespone.isSuccess = result.isSuccess;
          store.commonRespone.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // danh sách sản phẩm
    getListProduct: async (store, data) => {
      try {
        const result = await commonServices.getListProduct(data);
        runInAction(() => {
          store.productData.data = result.data;
          store.productData.isSuccess = result.isSuccess;
          store.productData.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // get domain email
    getDomainEmail: async (store) => {
      try {
        const result = await commonServices.getDomainEmail();
        runInAction(() => {
          store.commonRespone.data = result.data;
          store.commonRespone.isSuccess = result.isSuccess;
          store.commonRespone.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // get email type
    getEmailType: async (store) => {
      try {
        const result = await commonServices.getEmailType();
        runInAction(() => {
          store.commonRespone.data = result.data;
          store.commonRespone.isSuccess = result.isSuccess;
          store.commonRespone.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // getListProgram
    getListProgram: async (store, key) => {
      try {
        const result = await commonServices.getListProgram(key);
        runInAction(() => {
          store.commonRespone.data = result.data;
          store.commonRespone.isSuccess = result.isSuccess;
          store.commonRespone.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // getListProgram
    getListRole: async (store, role, company) => {
      try {
        const result = await commonServices.getListRole(role, company);
        runInAction(() => {
          store.commonRespone.data = result.data;
          store.commonRespone.isSuccess = result.isSuccess;
          store.commonRespone.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
  };
}
